import { Box } from '@chakra-ui/react';

import {
  NotificationBanner,
  NotificationBannerCarousel,
} from '../../components/custom';
import RepresentativeCard from '../../components/custom/Representative/RepresentativeCard';
import useRepresentativePrompt from '../../components/custom/Representative/useRepresentativePrompt';
import DirectorsAdditionalInfoCard from '../../modules/Dashboard/AddDirectors/DirectorsAdditionalInformation/DirectorsAdditionalInfoCard';
import useDirectorsAdditionalInfoPrompt from '../../modules/Dashboard/AddDirectors/DirectorsAdditionalInformation/useDirectorsAdditionalInfoPrompt';
import AdditionalDocumentCard from '../../modules/KYBSetup/AdditionalDocument/AdditionalDocumentCard';
import useAdditionalDocumentPrompt from '../../modules/KYBSetup/AdditionalDocument/useAdditionalDocumentPrompt';
import TransactionsApprovalCard from '../../modules/Settings/AccountManagement/TransactionMandatesApproval/PendingTransactionsForApproval/TransactionsApprovalCard';
import useTransactionsApprovalPrompt from '../../modules/Settings/AccountManagement/TransactionMandatesApproval/PendingTransactionsForApproval/useTransactionsApprovalPrompt';

export default function LayoutNotificationBanners() {
  // Each hook owns its own fetch, so they must run on every route even when
  // the banner itself is only eligible on the dashboard.
  const { showBanner: showRepresentative } = useRepresentativePrompt();
  const { showBanner: showAdditionalDocument, reason } =
    useAdditionalDocumentPrompt();
  const { showBanner: showDirectorsInfo } = useDirectorsAdditionalInfoPrompt();
  const { showBanner: showTransactionsApproval } =
    useTransactionsApprovalPrompt();

  // Push order is the carousel order, matching how these used to stack.
  const banners: NotificationBanner[] = [];

  if (showRepresentative) {
    banners.push({ id: 'representative', content: <RepresentativeCard /> });
  }

  if (showAdditionalDocument) {
    banners.push({
      id: 'additional-document',
      content: <AdditionalDocumentCard reason={reason} />,
    });
  }

  if (showDirectorsInfo) {
    banners.push({
      id: 'directors-additional-info',
      content: <DirectorsAdditionalInfoCard />,
    });
  }

  if (showTransactionsApproval) {
    banners.push({
      id: 'transactions-approval',
      content: <TransactionsApprovalCard />,
    });
  }

  if (banners.length === 0) return null;

  return (
    <Box mb="62px">
      <NotificationBannerCarousel
        banners={banners}
        label="Account notifications"
      />
    </Box>
  );
}
